(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carverall-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carverall-sticky-purchase')) {
    customElements.define('carverall-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.start());
      }
      start() {
        this.form = document.getElementById(this.dataset.form);
        this.root = this.closest('.cx-product, product-info');
        this.mainButton = this.form?.querySelector('[name="add"]');
        if (!this.root || !this.mainButton) return;
        this.area = this.mainButton.closest('.cx-purchase, .product-form__buttons');
        this.cx = this.dataset.adapter === 'cx';
        this.paymentSlot = this.querySelector('[data-cv-payment]');
        this.add = this.querySelector('[data-cv-add]');
        this.priceNode = this.querySelector('[data-cv-price]');
        this.compareNode = this.querySelector('[data-cv-compare]');
        this.saving = this.querySelector('[data-cv-saving]');
        this.titleNode = this.querySelector('[data-cv-title]');
        this.selectionNode = this.querySelector('[data-cv-selection]');
        this.variant = JSON.parse(this.querySelector('[data-cv-variant]').textContent || 'null');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency });
        this.desktop = matchMedia('(min-width: 750px)');
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
        };
        this.root.addEventListener('change', this.schedule, { signal });
        this.root.addEventListener('input', this.schedule, { signal });
        document.addEventListener('click', this.schedule, { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        window.visualViewport?.addEventListener('resize', this.schedule, { signal });
        document.addEventListener('afterVariantChanged', (event) => {
          if (event.detail.sectionId !== this.dataset.section) return;
          this.variant = event.detail.variant;
          this.schedule();
        }, { signal });
        document.addEventListener('afterQuantityUpdate', this.schedule, { signal });
        document.addEventListener('optionValueSelectionChange', this.schedule, { signal });
        this.observer = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'hidden', 'value'] });
        this.bodyObserver = new MutationObserver(this.schedule);
        this.bodyObserver.observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.area);
        this.querySelector('[data-cv-configure]').addEventListener('click', () => this.configure(), { signal });
        this.add.addEventListener('click', () => this.purchase(), { signal });
        this.refresh();
      }
      text(node, value) {
        if (node && node.textContent !== value) node.textContent = value;
      }
      readState() {
        const id = this.form.querySelector('[name="id"]')?.value;
        const quantityInput = this.form.elements.namedItem('quantity');
        const quantity = Number(quantityInput?.value || 1);
        let variant = this.variant;
        let title = this.dataset.productTitle;
        let options = variant?.title === 'Default Title' ? '' : variant?.title || '';
        let extras = [];
        let card;
        if (this.cx) {
          card = this.root.querySelector('[data-package].is-selected');
          const values = [...(card?.querySelectorAll('[data-package-option]') || [])].map(input => input.value);
          const variants = JSON.parse(card?.querySelector('[data-package-variants]')?.textContent || '[]');
          variant = variants.find(item => String(item.id) === id && (!values.length || item.options.every((value, index) => value === values[index])));
          title = card?.querySelector('.cx-package__copy strong')?.textContent.trim() || title;
          options = values.join(' / ');
          extras = [...this.root.querySelectorAll('[data-addon-id]:checked, [data-warranty-id]:checked')];
        }
        const valid = Boolean(id && variant && String(variant.id) === id && Number.isInteger(quantity) && quantity > 0 && (!quantityInput || quantityInput.checkValidity()));
        const extraPrice = extras.reduce((sum, input) => sum + Number(input.dataset.addonPrice || input.dataset.warrantyPrice || 0), 0);
        let unitPrice = Number(variant?.price || 0);
        const breaks = variant?.quantity_price_breaks || [];
        const pricingQuantity = quantity + Number(quantityInput?.dataset.cartQuantity || 0);
        breaks.forEach(breakpoint => { if (pricingQuantity >= breakpoint.minimum_quantity) unitPrice = Number(breakpoint.price); });
        const price = unitPrice * quantity + extraPrice;
        const compare = Math.max(Number(variant?.compare_at_price || 0), unitPrice) * quantity + extraPrice;
        const selection = [options, `${this.dataset.quantityLabel}: ${Number.isFinite(quantity) ? quantity : '—'}`, ...extras.map(input => input.closest('[data-addon-card], label')?.querySelector('strong')?.textContent.trim()).filter(Boolean)].filter(Boolean).join(' · ');
        return { valid, title, selection, price, compare, quantityInput, available: variant?.available, allowPayment: valid && !extras.length && (!this.cx || card?.dataset.packageStandalone === 'true') };
      }
      blocked() {
        const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .7;
        const modal = [...document.querySelectorAll('dialog[open], cart-drawer.active, .drawer.active, [aria-modal="true"], #shopify-pc__banner, .cookies-banner:not(.hidden)')].some(node => {
          const rect = node.getBoundingClientRect();
          const style = getComputedStyle(node);
          return rect.width > 1 && rect.height > 1 && style.visibility !== 'hidden' && style.opacity !== '0';
        });
        return keyboard || modal || document.querySelector('#Avada-FAQ_WidgetTrigger[aria-expanded="true"]');
      }
      refresh() {
        if (!this.isConnected || !this.mainButton.isConnected) return;
        const stableLayout = this.hasAttribute('data-cv-stable-layout');
        const areaBottom = this.area.getBoundingClientRect().bottom;
        const c1Visibility = stableLayout
          ? areaBottom < (this.hidden ? -8 : 8) && !this.blocked()
          : this.hasAttribute('data-cv-c1-layout')
            ? areaBottom < 0 && !this.blocked()
            : null;
        if (c1Visibility === false && this.hidden && (!this.payment || this.payment.parentElement !== this.paymentSlot)) return;
        const state = this.readState();
        const busy = this.mainButton.getAttribute('aria-busy') === 'true' || this.mainButton.classList.contains('loading');
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true' || state.available === false;
        this.text(this.titleNode, state.title);
        this.text(this.selectionNode, state.selection);
        this.selectionNode.title = state.selection;
        this.text(this.priceNode, state.valid ? this.money.format(state.price / 100) : '—');
        this.compareNode.hidden = !state.valid || state.compare <= state.price;
        this.saving.hidden = this.compareNode.hidden;
        this.text(this.compareNode, this.money.format(state.compare / 100));
        this.text(this.querySelector('[data-cv-saved]'), this.money.format((state.compare - state.price) / 100));
        const label = busy ? this.dataset.loadingLabel : !state.valid ? this.dataset.chooseLabel : this.mainButton.querySelector('[data-add-label], span')?.textContent.trim();
        this.text(this.add, label || this.dataset.chooseLabel);
        this.add.disabled = busy || (state.valid && disabled);
        this.add.setAttribute('aria-busy', String(busy));
        const visible = c1Visibility === null
          ? this.area.getBoundingClientRect().bottom < 0 && !this.blocked()
          : c1Visibility;
        this.hidden = !visible;
        this.movePayment(visible && this.desktop.matches && state.allowPayment && !disabled && !busy);
        if (visible) {
          const height = `${Math.ceil(this.getBoundingClientRect().height)}px`;
          if (document.body.style.getPropertyValue('--cv-purchase-height') !== height) document.body.style.setProperty('--cv-purchase-height', height);
        }
        document.body.classList.toggle('cv-purchase-active', visible);
        this.offsetWidget(visible);
      }
      offsetWidget(active) {
        if (!active) {
          this.widgetObserver?.disconnect();
          if (this.widget && this.widgetBottom) {
            this.widget.style.setProperty('bottom', this.widgetBottom.value, this.widgetBottom.priority);
          }
          this.widget = null;
          this.widgetBottom = null;
          this.widgetWritten = null;
          return;
        }
        const widget = document.getElementById('google-merchantwidget-iframe-wrapper');
        if (!widget) return;
        if (this.widget !== widget) {
          this.widgetObserver?.disconnect();
          this.widget = widget;
          this.widgetObserver = new MutationObserver(this.schedule);
          this.widgetObserver.observe(widget, { attributes: true, attributeFilter: ['style'] });
        }
        if (!this.widgetBottom || widget.style.getPropertyValue('bottom') !== this.widgetWritten) {
          this.widgetBottom = { value: widget.style.getPropertyValue('bottom'), priority: widget.style.getPropertyPriority('bottom') };
        }
        const bottom = `${Math.max(parseFloat(this.widgetBottom.value) || 0, Math.ceil(this.getBoundingClientRect().height) + 16)}px`;
        if (widget.style.getPropertyValue('bottom') !== bottom) widget.style.setProperty('bottom', bottom, 'important');
        this.widgetWritten = bottom;
      }
      movePayment(active) {
        if (!this.payment) {
          this.payment = this.form.querySelector('[data-payment-button], .shopify-payment-button');
          if (!this.payment) return;
          this.placeholder = document.createElement('div');
          if (this.hasAttribute('data-cv-c1-layout') || this.hasAttribute('data-cv-stable-layout')) this.placeholder.className = 'cv-purchase__payment-placeholder';
          this.placeholder.hidden = true;
          this.placeholder.setAttribute('aria-hidden', 'true');
          this.payment.before(this.placeholder);
        }
        active = active && !this.payment.hidden;
        if (active && this.payment.parentElement !== this.paymentSlot) {
          this.placeholder.style.height = `${this.payment.getBoundingClientRect().height}px`;
          this.placeholder.style.width = '100%';
          if (this.hasAttribute('data-cv-c1-layout') || this.hasAttribute('data-cv-stable-layout')) {
            const paymentStyle = getComputedStyle(this.payment);
            this.placeholder.style.marginTop = paymentStyle.marginTop;
            this.placeholder.style.marginBottom = paymentStyle.marginBottom;
          }
          this.placeholder.hidden = false;
          this.paymentSlot.append(this.payment);
        } else if (!active && this.payment.parentElement === this.paymentSlot) {
          this.placeholder.after(this.payment);
          this.placeholder.hidden = true;
        }
        this.paymentSlot.hidden = !active;
      }
      configure(invalid) {
        const target = invalid || this.root.querySelector('.cx-packages, variant-selects, variant-radios') || this.area;
        const y = window.scrollY + target.getBoundingClientRect().top - 140;
        window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const focus = invalid || target.querySelector('select, input:not([type="hidden"]), button, [tabindex="0"]') || this.mainButton;
        focus?.focus({ preventScroll: true });
      }
      purchase() {
        const state = this.readState();
        if (!state.valid) { this.configure(state.quantityInput && !state.quantityInput.checkValidity() ? state.quantityInput : null); return; }
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        const invalid = [...this.form.elements].find(input => input.willValidate && !input.checkValidity());
        if (invalid) { this.configure(invalid); invalid.reportValidity(); return; }
        this.mainButton.click();
        this.schedule();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.observer?.disconnect();
        this.bodyObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.offsetWidget(false);
        if (this.payment && this.placeholder?.isConnected) this.placeholder.after(this.payment);
        this.placeholder?.remove();
        if (!document.querySelector('carverall-sticky-purchase:not([hidden])')) {
          document.body.classList.remove('cv-purchase-active');
          document.body.style.removeProperty('--cv-purchase-height');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('header-country-selector')) {
    customElements.define(
      'header-country-selector',
      class HeaderCountrySelector extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.searchInput = this.querySelector('[data-country-search]');
          this.details = this.querySelector('details');
          this.panel = this.querySelector('.country-selector__panel');
          this.list = this.querySelector('[data-country-list]');
          this.options = Array.from(this.querySelectorAll('[data-country-option]'));
          this.groups = Array.from(this.querySelectorAll('[data-country-group]'));

          if (!this.searchInput || !this.details) return;

          this.searchInput.addEventListener('input', this.filterCountries.bind(this));
          this.searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') event.preventDefault();
          });
          this.details.addEventListener('toggle', () => {
            if (this.details.open) {
              this.loadCountryFlags();
              this.positionPanel();
              requestAnimationFrame(() => this.searchInput.focus());
            } else {
              this.resetSearch();
            }
          });
          if (this.details.open) this.loadCountryFlags();
        }

        loadCountryFlags() {
          this.querySelectorAll('[data-country-flag-src]').forEach((image) => {
            image.src = image.dataset.countryFlagSrc;
            delete image.dataset.countryFlagSrc;
          });
        }

        positionPanel() {
          if (!this.panel) return;

          const gutter = 10;
          const viewportWidth = document.documentElement.clientWidth;
          const viewportHeight = window.innerHeight;
          this.panel.style.removeProperty('--country-selector-panel-max-height');
          this.panel.style.removeProperty('--country-selector-list-max-height');
          this.panel.style.setProperty('--country-selector-offset-x', '0px');
          let panelRect = this.panel.getBoundingClientRect();
          const availableHeight = Math.max(120, viewportHeight - panelRect.top - gutter);

          this.panel.style.setProperty('--country-selector-panel-max-height', `${availableHeight}px`);
          if (this.list) {
            this.panel.style.setProperty('--country-selector-list-max-height', `${Math.max(80, availableHeight - 70)}px`);
          }

          panelRect = this.panel.getBoundingClientRect();
          let offset = 0;

          if (panelRect.left < gutter) {
            offset = gutter - panelRect.left;
          } else if (panelRect.right > viewportWidth - gutter) {
            offset = viewportWidth - gutter - panelRect.right;
          }

          this.panel.style.setProperty('--country-selector-offset-x', `${offset}px`);
        }

        filterCountries() {
          const query = this.searchInput.value.trim().toLocaleLowerCase();

          this.options.forEach((option) => {
            const item = option.closest('[data-country-item]');
            item.hidden = query !== '' && !option.dataset.countrySearchValue.includes(query);
          });

          this.groups.forEach((group) => {
            group.hidden = !group.querySelector('[data-country-item]:not([hidden])');
          });
        }

        resetSearch() {
          this.searchInput.value = '';
          this.options.forEach((option) => {
            option.closest('[data-country-item]').hidden = false;
          });
          this.groups.forEach((group) => {
            group.hidden = false;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["z12-native-media"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.z12YouTubePostersReady) return;
  window.z12YouTubePostersReady = true;
  const fallback = (img) => {
    if (img.dataset.z12nPosterFailed === 'true') return;
    const next = img.dataset.z12nPosterFallback;
    if (next) {
      delete img.dataset.z12nPosterFallback;
      img.src = next;
    } else {
      img.dataset.z12nPosterFailed = 'true';
      img.closest('[data-z12n-video-poster]')?.remove();
    }
  };
  const inspect = (img) => {
    if (img.complete && (!img.naturalWidth || img.naturalWidth <= 120)) fallback(img);
  };
  document.addEventListener('error', (event) => {
    if (event.target.matches?.('[data-z12n-youtube-poster]')) fallback(event.target);
  }, true);
  document.addEventListener('load', (event) => {
    if (event.target.matches?.('[data-z12n-youtube-poster]')) inspect(event.target);
  }, true);
  const boot = (scope = document) => scope.querySelectorAll('[data-z12n-youtube-poster]').forEach(inspect);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot(), { once: true }) : boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
